<template>

  <div class="form-group form-group-w-btn">
    <label>
      <!--{{tituloUpload}}-->
      <input type="file" :id="idInput" :name="idInput" ref="file"/>
    </label>

  </div>

</template>

<script>

import VuesticFileUpload from '../../../vuestic-theme/vuestic-components/vuestic-file-upload/VuesticFileUpload'

export default {
  name: 'InputUploadGroup',
  data () {
    return {
      advancedGallery: [],
      advancedList: [],
      single: [],
      gallery: [],
      list: []
    }
  },
  components: { VuesticFileUpload },

  props: {
    // idInput: {
    //   type: String,
    //   required: true
    // },
    // iconInput: {
    //   type: String,
    //   required: true
    // },
    // labelInput: {
    //   type: String,
    //   required: true
    // },
    tituloUpload: {
      type: String,
      required: true,
      default: function () {
        return 'Upload'
      }
    },
    // typeInput: {
    //   type: String,
    //   required: false,
    //   default: function () {
    //     return 'text'
    //   }
    // },
    // inputMask: {
    //   type: Array,
    //   required: false,
    //   default: function () {
    //     return null
    //   }
    // },
    // inputDisabled: {
    //   type: String,
    //   required: false,
    //   default: function () {
    //     return null
    //   }
    // },
  },
  methods: {
    clear () {
      document.getElementById(this.idInput).value = ''
    }
  }
}
</script>

<style scoped>

</style>
